import { PageHeader } from "@/components/site/PageHeader";
import { Seo } from "@/components/site/Seo";
import { Courses } from "@/components/site/Courses";
import { HowItWorks } from "@/components/site/HowItWorks";
import { UpcomingDates } from "@/components/site/UpcomingDates";
import { LeadMagnet } from "@/components/site/LeadMagnet";

export default function Corsi() {
  return (
    <div data-testid="corsi-page">
      <Seo
        title="Corsi di Formazione a Frosinone | treffe — Centro di Formazione 3F"
        description="Corsi di formazione a Frosinone per aziende, lavoratori e privati: sicurezza D.Lgs 81/08, antincendio, primo soccorso, BLS-D laico e sanitario, attrezzature, cantieri, rischi specifici, HACCP e Istruttore AHA."
        path="/corsi"
      />
      <PageHeader
        eyebrow="I nostri corsi"
        title={<>Formazione e aggiornamento professionale</>}
        subtitle="Corsi per aziende, lavoratori e privati nei principali ambiti della sicurezza, dell'emergenza e della formazione professionale, con percorsi teorici e pratici e certificazioni riconosciute."
      />
      <Courses showHeader={false} />
      <HowItWorks />
      <UpcomingDates />
      <LeadMagnet />
    </div>
  );
}
